import { css } from "@emotion/react";

export const spacingLeft = css`
  margin-left: 2.5rem;
`;
